<template>
  <div class="itemContent">
    <div class="user_info" @click="goCommentDetails(data.id)">
      <div class="user_info_left">
        <img :src="data.avatar" alt="" />
       <div>
          <div>
            <span :style="data.super == '1'?'color:#FF7517':''">{{ data.full_name }}</span>
            <img
              v-if="data.super == '1'"
              src="../../../../assets/game/yz_game_commentmonthVip01.png"
              alt=""
            />
          </div>
          <span class="time">{{ data.createtime }}</span>
       </div>
      </div>
      <div class="user_info_right" v-if="data.score">
        <img :src="state.scoreGrade" alt="" >
      </div>
    </div>

    <div class="user_comment" @click="goCommentDetails(data.id)">
      <div>
        <h3>{{ data.title}}</h3>
        <p v-html="data.content" class="editorText"></p>
      </div>
      <div>
        <ul>
          <li v-for="(itemImg, indexImg) in data.url" :key="indexImg + 'img'">
            <img :src="itemImg" alt="" />
          </li>
          <!-- 图片遮罩层 -->
          <li v-if="data.url && data.url.length > 2" class="moreImg">
            <span> +{{ data.url.length - 2 }} </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="first_reply" v-if = "data.listscomments ">
      <p>{{ deCodeEmoji(data.listscomments) }}</p>
    </div>

    <div class="user_bottom">
      
      <div class="user_bottom_left">
        <!-- 精选标识 -->
        <span class="choiceness" v-if="data.is_jh == '1'">精</span>
        <span v-if="data.ctypename">{{ data.ctypename }}</span>
      </div>
      <div class="user_bottom_right">

        <div class="deletComment" v-if="props.deletePermission">
          <img src="../../../../assets/gameCommunity/icon_gameCommunity_delete.png" alt="" @click="deleteComment(data.id)">
        </div>

        <div class="review">
          <img src="../../../../assets/game/yz_game_reviewComunity.png" alt="" />
          <span>{{ data.number_reply }}</span>
        </div>

        <div class="like" @click="likeThisComment(data.id)">
          <img
            src="../../../../assets/game/yz_game_likeComunity.png"
            alt=""
            v-if="state.isLike.includes(data.id)"
          />
          <img
            src="../../../../assets/game/yz_game_notLikeComunity.png"
            alt=""
            v-else
          />
          <span>{{ data.good }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted,defineEmits,reactive, onActivated  } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { enCodeEmoji, deCodeEmoji } from "@/utils/emojiToCode";

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  like:{
    type: Array,
    default: () =>[],
  },
  deletePermission: {
    type: Boolean,
    default: () => false,
  },
});

//子组件触发父组件事件
const emit = defineEmits(["likeThisComment", "goCommentDetails","deleteComment"]);

const state = reactive({
  isLike: [],
  scoreGrade:'',
});

onMounted(() => {
  // console.log("评论信息组件挂载了---------------------", props.data);
  //   console.log("评论信息组件挂载了---------------------", props.like);
    state.isLike = props.like;

    switch (props.data.score) {
      case '+10积分':
        //引入图片
        state.scoreGrade =require("../../../../assets/gameCommunity/score10.png");
        break;
      case '+20积分':
        state.scoreGrade =require("../../../../assets/gameCommunity/score20.png");
        break;
      case '+30积分':
        state.scoreGrade =require("../../../../assets/gameCommunity/score30.png");
        break;
      default:
        state.scoreGrade = "";
        break;
    }
});

const likeThisComment = (id) => {
  emit("likeThisComment", id);
};
const goCommentDetails = (id) => {
  emit("goCommentDetails", id);
};
const deleteComment = (id) => {
  emit("deleteComment",id);
};

</script>

<style scoped>
.itemContent {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 24px;
  border-radius: 20px;
}
.user_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user_info .user_info_left {
  display: flex;
  align-items: center;
}
.user_info .user_info_left img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
}
.user_info .user_info_left div img {
  width: 56px;
  height: 22px;
  margin-left: 4px;
  border-radius: 0;
}
.user_info .user_info_left div {
  padding-top: 10px;
}
.user_info .user_info_left div div {
  display: flex;
  align-items: center;
  line-height: 0;
  color: #333;
}
.user_info .user_info_left div .time {
  margin-top: 12px;
  font-size: 20px;
  color: #333;
  display: inline-block;
}
.user_info .user_info_right {
  /* width: 105px; */
  height: 32px;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  color: #fff;
}
.user_info .user_info_right img {
  width: 80px;
  height: 80px;
}
.user_comment {
  width: 638px;
  min-height: 86px;
  /* margin-left: 120px; */
  font-size: 30px;
  color: #333;
  margin-top: 8px;
}
.user_comment div {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  text-overflow: ellipsis;
}
.user_comment div p {
  text-overflow: ellipsis;
}
.user_comment img {
  width: 308px;
  /* min-height: 200px */
}
.user_comment ul {
  display: flex;
  position: relative;
  padding-top: 32px;
}
.user_comment ul li {
  height: 100%;
}
.user_comment div:nth-of-type(2) img {
  margin-right: 16px;
  border-radius: 10px;
  height: 100%;
}

/* 第一条评论回顾样式 */
.first_reply {
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 638px;
  height: 76px;
  border-radius: 20px;
  background-color: #f1f1f1;
}
.first_reply p{
  flex: 1;
  text-wrap: nowrap;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  color:#333;
}

.user_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  /* margin-left: 120px; */
  font-size: 24px;
  color: #999999;
}
.user_bottom .user_bottom_left {
  display: flex;
}
.user_bottom .user_bottom_left span {
  /* width: 80px; */
  padding: 0 20px;
  height: 32px;
  border-radius: 42px;
  background-color: #f1f1f1;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_bottom .user_bottom_left .choiceness {
  background-color: #ff5656;
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
  margin-right: 12px;
}
.user_bottom .user_bottom_right {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-size: 20px;
}
.user_bottom .user_bottom_right .deletComment {
  margin-right: 40px;
}
.user_bottom .user_bottom_right div {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.user_bottom_right div span {
  right: -10px;
  top: -15px;
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.user_bottom .user_bottom_right img {
  width: 36px;
  height: 36px;
  margin-right: 4px;
  margin-bottom: 6px;
}
.user_bottom_right .review {
  display: flex;
  align-items: center;
  margin-right: 34px;
  position: relative;
}
.user_bottom_right .review span {
  right: -10px;
  top: -15px;
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.giveComment {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  position: fixed;
  right: 40px;
  bottom: 250px;
  background: linear-gradient(135deg, #8061ff 0%, #9c85fb 100%);
  border: 6px solid #664fc3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
.giveComment img {
  width: 40px;
  height: 40px;
}
.backToTop {
  position: fixed;
  right: 40px;
  bottom: 100px;
}
.backToTop img {
  width: 100px;
  height: 100px;
}
:deep(.van-cell:after) {
  position: relative;
}

.user_comment .moreImg {
  width: 308px;
  height: 100%;
  position: absolute;
  right: 8px;
  /* top: 32px; */
  color: #fff;
  font-size: 50px;
  padding-bottom: 50px;
}
.user_comment .moreImg span {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 101%;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
